import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { "data-qa": "social-media-actions" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_copy_to_clipboard = _resolveComponent("copy-to-clipboard")
  const _component_base_icon = _resolveComponent("base-icon")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.enableCopy)
      ? (_openBlock(), _createBlock(_component_copy_to_clipboard, {
          key: 0,
          "text-to-copy": $props.shareUrl,
          fixed: true,
          "vertical-position": "down",
          class: "gfu-social-media-action",
          "data-qa": "social-media-actions:Copy"
        }, null, 8 /* PROPS */, ["text-to-copy"]))
      : _createCommentVNode("v-if", true),
    ($props.enableFacebook)
      ? (_openBlock(), _createElementBlock("span", {
          key: 1,
          class: "gfu-link gfu-link--inline gfu-link--nofx gfu-social-media-action",
          onClick: _cache[0] || (_cache[0] = _withModifiers((...args) => ($options.shareOnFacebook && $options.shareOnFacebook(...args)), ["prevent","stop"]))
        }, [
          _createVNode(_component_base_icon, {
            "icon-namespace": "brands",
            name: "facebook",
            "data-qa": "social-media-actions:Facebook"
          })
        ]))
      : _createCommentVNode("v-if", true),
    ($props.enableTwitter)
      ? (_openBlock(), _createElementBlock("span", {
          key: 2,
          class: "gfu-link gfu-link--inline gfu-link--nofx gfu-social-media-action",
          onClick: _cache[1] || (_cache[1] = _withModifiers((...args) => ($options.shareOnTwitter && $options.shareOnTwitter(...args)), ["prevent","stop"]))
        }, [
          _createVNode(_component_base_icon, {
            "icon-namespace": "brands",
            name: "x-twitter",
            "data-qa": "social-media-actions:Twitter"
          })
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}